import { observer } from 'mobx-react';

import styles from './DiscountEditor.module.scss';

import { DiscountType } from 'chaika-enums';
import { HurdleDiscountParams } from 'chaika-frontend-types/frontend-cms';

import { Select } from '@components/Select';
import { translate } from '@chaika/i18n/helper';
import { useDiscountEditor } from '@common/CreationMenuFields/DiscountEditor/hooks/useDiscountEditor';
import { Input } from '@components/Input';
import { HurdleDiscount } from '@common/CreationMenuFields/DiscountEditor/HurdleDiscount';

interface Props {
    value: Discount;
    disabled?: boolean;
    onChange(params: any): void;
}

export interface Discount {
    discountType: DiscountType;
    flatDiscount?: number;
    averageDiscount?: number;
    hurdleDiscount?: HurdleDiscountParams[];
}

export const DiscountEditor = observer(({ value, disabled, onChange }: Props) => {
    const {
        discountTypeOptions,
        discountType,
        discounts,
        onChangeDiscountTypeSwitcher,
        onChangeNumberField,
        onChangeHurdleField,
    } = useDiscountEditor({
        value,
        onChange,
    });

    const isFlat = discountType === DiscountType.Flat;
    const isAverage = discountType === DiscountType.Average;
    const isHurdle = discountType === DiscountType.Hurdle;

    return (
        <div className={styles.root}>
            <Select
                isSearchable
                disabled={disabled}
                title={translate('discountType')}
                selectedValue={discountType}
                options={discountTypeOptions}
                onChange={onChangeDiscountTypeSwitcher}
            />
            {isFlat && (
                <Input
                    title={translate('discountTypeFlat')}
                    type={'number'}
                    min={0}
                    max={1}
                    name={'flatDiscount'}
                    value={discounts.flatDiscount ?? 0}
                    disabled={disabled}
                    dataTest={''}
                    onChange={onChangeNumberField}
                />
            )}
            {isAverage && (
                <Input
                    title={translate('discountTypeAverage')}
                    type={'number'}
                    min={0}
                    max={100}
                    name={'averageDiscount'}
                    value={discounts.averageDiscount ?? 0}
                    disabled={disabled}
                    dataTest={''}
                    onChange={onChangeNumberField}
                />
            )}
            {isHurdle && (
                <HurdleDiscount
                    params={discounts.hurdleDiscount}
                    onChange={onChangeHurdleField}
                />
            )}
        </div>
    );
});
